const getDefaultState = function () {
  return {
    userId: null,
    socId: null,
    rightId: null,
    name: "",
    login: "",
    permissions: "",
    dir: "",
    players: [],
    emailIsValid: "", // true si email valide, false si email invalide, "" si email non déclaré
    aikido: "",
    token: "",
  };
};

const state = getDefaultState();

const mutations = {
  AUTHENTIFIED: function (state, data) {
    state.userId = data.userId;
    state.socId = data.socId;
    state.rightId = data.rightId;
    state.name = data.name;
    state.login = data.login;
    state.permissions = data.permissions;
    state.dir = data.dir;
    state.players = data.players;
    state.aikido = data.aikido;
    state.token = data.token;
  },

  DISCONNECT: function (state) {
    Object.assign(state, getDefaultState());
  },

  MAILVERIFIED: function (state, isValid) {
    state.emailIsValid = isValid;
  },
};

const actions = {
  authentified: ({ commit }, data) => {
    commit("AUTHENTIFIED", data);
  },

  disconnect: ({ commit }) => {
    commit("DISCONNECT");
  },

  mailVerified({ commit }, isValid) {
    commit("MAILVERIFIED", isValid);
  },
};

export default {
  state,
  mutations,
  actions,
};
